export const INFO = {
  TITLE: 'Your completion of the NCCN Distress Thermometer allows us to provide more individualised patient care',
  PARA_1:
    'Distress is an unpleasant experience of mental, physical, social or spiritual nature. It can affect the way you think, feel, or act. Distress may make it harder to cope with having cancer, its symptoms and its treatment.',
  PARA_2:
    'The answers from your Distress Thermometer are reviewed by your care team with the aim to better support you throughout your cancer journey at GenesisCare.',
  PARA_3:
    'To note: this tool is not reviewed in isolation and may not be seen until your consultation. If you have any immediate or severe medical concerns that you are raising here, please escalate these immediately to your existing doctor or call 000 if needed.',
};
